import { RESET_COLOR } from './constants/ANSI_COLORS';

/**
 * Prints a message with a specific color to the console.
 *
 * @param {Object} options - The options for printing the message.
 * @param {string} options.message - The message to be printed.
 * @param {string} options.color - The color in which the message will be printed.
 * @returns {void}
 */

export const printByColor = ({ message, color }) =>
    console.log(`${color}${message}${RESET_COLOR}`);
